import { useTranslation } from 'react-i18next'

import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from '@mui/material/Tooltip'
import EditRoundedIcon from '@mui/icons-material/EditRounded'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type SummaryProps = {
  disableEdit?: boolean
  label: string
  onEdit?: () => void
  text?: string
}

export function Summary(props: SummaryProps) {
  const { disableEdit, label, onEdit, text } = props
  const { t } = useTranslation()

  return (
    <ListItem sx={{ m: 0, pt: 0, pb: 0 }}>
      <ListItemText primary={<Stack>{label}</Stack>} secondary={text} sx={{ m: 0, '& .MuiListItemText-primary': { color: colors.gray700, fontWeight: 600 } }} />
      {!disableEdit && (
        <Tooltip title={t('common:button.modify.tooltip')}>
          <IconButton onClick={onEdit} size="small" sx={{ border: '0.5px solid' }}>
            <EditRoundedIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </ListItem>
  )
}

export default Summary
